<template>
  <div class="ApproveHistoryLine">
    <el-table
      ref="multipleTable"
      :data="itemApproveProcessVOs"
      size="mini"
      style="width: 100%; margin: 20px"
      height="100%"
      border
      :span-method="spanMethod"
    >
      <!-- <el-table-column type="index" width="50" label="序号"></el-table-column> -->
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.column.property == 'sort'">
            {{
              scope.row[scope.column.property] == -99
                ? "历史审批记录"
                : scope.row[scope.column.property]
            }}
          </div>
          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  getApproveListService, //查询审批列表
} from "@/services/approveServices";
export default {
  name: "ApproveHistoryLine",
  props: {
    approveType: {
      //审批类型
      type: String,
      default: "",
    },
    subapproveType: {
      //审批子类型
      type: String,
      default: "",
    },
    itemId: {
      //审批对象id
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      itemApproveProcessVOs: [], //审批信息列表
      tableColumnDatas: [
        { class: "sort", labelName: "排序", sortEnable: false },
        { class: "approveUserName", labelName: "姓名", sortEnable: false },
        { class: "deptName", labelName: "部门", sortEnable: false },
        { class: "jobName", labelName: "岗位", sortEnable: false },
        { class: "statusName", labelName: "状态", sortEnable: false },
        { class: "opinion", labelName: "审批意见", sortEnable: false },
        { class: "updateTime", labelName: "操作时间", sortEnable: false },
      ],
    };
  },
  watch: {
    itemId(value) {
      if (value !== 0&&value) {
        this.getApproveList();
      }
    },
  },
  mounted() {
    if (this.itemId !== 0&&this.itemId) {
      this.getApproveList(this.itemId);
    }
  },
  methods: {
    //获取审批信息列表
    getApproveList() {
      let param = {};
      param.itemId = this.itemId; //审批对象id
      param.approveClass = this.approveType; //审批类型
      getApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.itemApproveProcessVOs = res.data; //审批流历史审批数据
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
      const fields = ['sort']
      // 当前行的数据
      const cellValue = row[column.property]     
        // 判断只合并定义字段的列数据
        if (cellValue && fields.includes(column.property)) {
          const prevRow = this.itemApproveProcessVOs[rowIndex - 1] //上一行数据
          let nextRow = this.itemApproveProcessVOs[rowIndex + 1] //下一行数据
          // 当上一行的数据等于当前行数据时，当前行单元格隐藏
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
            let countRowspan = 1 //用于合并计数多少单元格
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = this.itemApproveProcessVOs[++countRowspan + rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }

    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.ApproveHistoryLine {
  background-color: white;
  .el-input {
    width: 80%;
    padding-bottom: 12px;
  }
  .buttons {
    margin-top: 20px;
    margin-left: 60px;
  }
}
</style>
